import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class Gallery extends Component {
  state = {
    allJobs: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 10,
    },
    notification: false,
    noticolor: "success",
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllGalleryImages(this.state.page_no, this.state.per_page);
  }

  getAllGalleryImages = (page, limit) => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getGallery}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp.data.status === true) {
            // New API: { status, data: [...], pagination: { page, limit, total, pages } }
            const items = resp.data.data || [];
            const pag = resp.data.pagination || {};

            const currentPage = pag.page || page || 1;
            const perPage = pag.limit || limit || 20;
            const totalDocs = pag.total || pag.totalDocs || items.length;
            const totalPages = pag.pages || pag.totalPages || Math.ceil(totalDocs / perPage);

            const hasNextPage =
              pag.hasNextPage !== undefined ? pag.hasNextPage : currentPage < totalPages;
            const hasPrevPage = pag.hasPrevPage !== undefined ? pag.hasPrevPage : currentPage > 1;

            const nextPage =
              pag.nextPage !== undefined ? pag.nextPage : hasNextPage ? currentPage + 1 : null;

            const prevPage =
              pag.prevPage !== undefined ? pag.prevPage : hasPrevPage ? currentPage - 1 : null;

            this.setState({
              allJobs: Array.isArray(items) ? items : [],
              pagination: {
                page: currentPage,
                limit: perPage,
                totalDocs,
                totalPages,
                hasNextPage,
                hasPrevPage,
                nextPage,
                prevPage,
              },
              page_no: currentPage,
              notification: true,
              noticolor: "success",
              message: resp.data.message || "Gallery fetched",
            });
            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Error fetching gallery",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllGalleryImages(1, newLimit); // reset to first page with new limit
    });
  };

  // ✅ Handle page change (from DataTable)
  handlePageChange = (newPage) => {
    this.getAllGalleryImages(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteGalleryImage + id)
        .then((resp) => {
          if (resp.data.status === true) {
            this.setState({
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  this.getAllGalleryImages(this.state.page_no, this.state.per_page);
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response?.message || "Delete failed",
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getAllGalleryImages(this.state.page_no, this.state.per_page);
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  renderMedia = (item) => {
    const src = Constants.imageDomain + item.image;
    const type = item.form_type || "image";

    // fallback: detect by extension if form_type missing/wrong
    const isVideoByExt = /\.(mp4|webm|ogg|mov|mkv)$/i.test(item.image || "");

    if (type === "video" || isVideoByExt) {
      return (
        <video src={src} controls style={{ height: "100px", width: "250px", objectFit: "cover" }}>
          Your browser does not support the video tag.
        </video>
      );
    }

    return (
      <img
        src={src}
        height="100px"
        style={{ width: "250px", objectFit: "cover" }}
        alt="Gallery Media"
      />
    );
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      const { pagination } = this.state;

      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Gallery
                  </MDTypography>
                </MDBox>
                <Grid item sm={4} px={2} align="right">
                  <Link to="/addgallery">
                    <MDButton variant="contained" size="small" color="primary">
                      Create
                    </MDButton>
                  </Link>
                </Grid>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "media", accessor: "media" },
                        { Header: "action", accessor: "action" },
                      ],
                      rows: this.state.allJobs.map((job, index) => ({
                        serial: (pagination.page - 1) * pagination.limit + (index + 1),
                        media: this.renderMedia(job),
                        action: (
                          <>
                            <div style={{ marginTop: "1rem" }}>
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="error"
                                onClick={() => this.handleDelete(job._id)}
                              >
                                Delete
                              </MDButton>
                            </div>
                          </>
                        ),
                      })),
                    }}
                    entriesPerPage={{ defaultValue: this.state.per_page }}
                    page_no={pagination?.page}
                    totalPages={pagination?.totalPages}
                    hasNextPage={pagination?.hasNextPage}
                    hasPrevPage={pagination?.hasPrevPage}
                    isnextPage={pagination?.nextPage}
                    prevPage={pagination?.prevPage}
                    totalDocs={pagination?.totalDocs}
                    onPageChange={this.handlePageChange}
                    onEntriesPerPageChange={this.handleEntriesPerPageChange}
                  />
                </MDBox>
                <MDSnackbar
                  color={this.state.noticolor}
                  icon="notifications"
                  title="VASA | Gallery"
                  content={this.state.message}
                  dateTime="Just now"
                  open={this.state.notification}
                />
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
